import React, { useState } from "react";
import secureAxios from "../utils/secureAxios";
import { getApiBaseURL } from "../utils/api";

const RequestPasswordReset = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const apiBase = getApiBaseURL();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("👉 API base:", apiBase);
      console.log("📨 Sending reset email for:", email);
      await secureAxios.post(`${apiBase}/api/auth/request-password-reset`, {
        email,
      });
      setMessage("✅ If the email exists, a reset link has been sent.");
    } catch (err) {
      console.error("❌ Error sending reset email:", err);
      setMessage("❌ Error sending reset link.");
    }
  };

  return (
    <div className="container mt-5">
      <h3>Reset Your Password</h3>
      {message && <p className="fw-bold">{message}</p>}
      <form onSubmit={handleSubmit}>
        <label className="form-label">Enter your email address</label>
        <input
          className="form-control mb-3"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button className="btn btn-primary" type="submit">
          Send Reset Link
        </button>
      </form>
    </div>
  );
};

export default RequestPasswordReset;
